import { createContext, useCallback, useContext } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

// How to leave a lead the user can no longer see (passed, deleted). The
// routed lead drawer (/leads/:leadId, …) goes up one route; a drawer opened
// over another page — the prospection map keeps it in state, not in the URL —
// provides its own close instead, since going up from /prospection lands on
// the dashboard.
export const LeadExitContext = createContext<(() => void) | null>(null);

export const useLeadExit = (): (() => void) => {
  const exit = useContext(LeadExitContext);
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback(() => {
    if (exit != null) {
      exit();
      return;
    }
    navigate({ pathname: '..', search: location.search });
  }, [exit, navigate, location.search]);
};
